import React from 'react';
import dayjs from 'dayjs';
import { AnalogTimePicker } from '../../../../../Components/Elements/AnalogTimePicker';

const parseTimeValue = (value) => {
    if (!value) {
        return null;
    }

    const parsed = dayjs(value, 'HH:mm', true);
    return parsed.isValid() ? parsed : null;
};

export const TimePickerBlock = ({ setting, onValueChange, controlSize = 'small', fullWidth = false }) => {
    const handleChange = (value) => {
        onValueChange(
            setting.id,
            value && value.isValid() ? value.format('HH:mm') : '',
            setting.parameter_type,
        );
    };

    return (
        <AnalogTimePicker
            disabled={!setting.is_active}
            value={parseTimeValue(setting.parameter_value)}
            onChange={handleChange}
            fullWidth={fullWidth}
            size={controlSize}
            slotProps={{
                textField: {
                    inputProps: {
                        'aria-label': `input ${setting.title}`,
                    },
                },
            }}
        />
    );
};
